/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as CONSTANTS from '../../../../SharedModules/AppConstants';

export const dispatchInvoiceDetailsByPQR = (data) => ({
  type: actionTypes.GET_INVOICE_REPORTS_BY_MFG,
  payload: data,
});

export const dispatchInvoiceDetailsByInvoiceNum = (data) => ({
  type: actionTypes.GET_DISP_INVOICE_DETAILS_BY_INVOICE_NUM,
  payload: data,
});

export const dispatchGetInvoiceStatusCode = (data) => {
  return {
    type: actionTypes.GET_INVOICE_CODE,
    payload: data,
  };
};

export const dispatchInvoiceQuarter = (data) => {
  return {
    type: actionTypes.GET_INVOICE_QUARTER,
    payload: data,
  };
};

export const dispatchInvoiceOtherQuarter = (data) => {
  return {
    type: actionTypes.GET_INVOICE_OTHER_QUARTER,
    payload: data,
  };
};

export const dispatchInvoiceQuarterTotals = (data) => {
  return {
    type: actionTypes.GET_INVOICE_QUARTER_TOTALS,
    payload: data,
  };
};

export const dispatchSavedInvoiceDetails = (data) => {
  return {
    type: actionTypes.SAVED_INVOICE_DETAILS,
    payload: data,
  };
};

export const dispatchDrugActivity = (data) => {
  return {
    type: actionTypes.GET_DRUG_ACTIVITY,
    payload: data,
  };
};

export const dispatchGetCheckLogByInvoiceNum = (data) => {
  return {
    type: actionTypes.GET_CHECK_LOG_BY_INVOICE_NUM,
    payload: data,
  };
};

export const setErrorMessagesData = (data) => {
  return {
    type: actionTypes.SET_ERROR_MESSAGES_INNVOICE_REPORT,
    payload: data,
  };
};

export const dispatchErrors = (data) => {
  return {
    type: actionTypes.SET_ERRORS,
    payload: data,
  };
};

export const setSaveRequest = (data) => {
  return {
    type: 'SET_SAVE_REQUEST',
    payload: data,
  };
};

export const searchInvoiceReportAction = (data) => {
  return {
    type: 'SEARCH_INVOICE_REPORT_REQUEST',
    payload: data,
  };
};

export const setSelectedClient = (data) => {
  return {
    type: actionTypes.SET_INVOICE_REPORT_SELECTED_CLIENT,
    payload: data,
  };
};

export const setInvoiceNumber = (data) => {
  return {
    type: actionTypes.SET_INVOICE_REPORT_NUMBER,
    payload: data,
  };
};

export const setCheckLogOpen = (data) => {
  return {
    type: 'SET_CHECK_LOG_OPEN',
    payload: data,
  };
};

export const setDefaultQtr = (data) => {
  return {
    type: actionTypes.SET_DEFAULT_QTR,
    defaultQtr: data,
  };
};

export const setIsSearchClicked = (data) => {
  return {
    type: actionTypes.SET_IS_SEARCH_CLICKED,
    payload: data,
  };
};

export const setNoRecordFound = (data) => {
  return {
    type: actionTypes.SET_INVOICE_REPORT_NO_RECORD_FOUND,
    payload: data,
  };
};

export const resetDisplayInvoiceReportStore = () => {
  return {
    type: actionTypes.RESET_DISPLAY_INVOICE_REPORT_STORE,
  };
};

const isNoRecordPayload = (data) => {
  if (data == null || data === '') return true;
  if (typeof data === 'string') {
    return data.toLowerCase().includes('no record');
  }
  if (Array.isArray(data) && data.length === 0) return true;
  return false;
};

export const searchInvoiceByPQR = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SEARCH_INVOICE_BY_PQR, values)
    .then((response) => {
      const data = response?.data?.data;
      if (isNoRecordPayload(data)) {
        dispatch(dispatchInvoiceDetailsByPQR([]));
        return { isNoRecord: true, data: [] };
      }
      dispatch(dispatchInvoiceDetailsByPQR(data));
      return { isNoRecord: false, data };
    })
    .catch((error) => {
      const errorData = error?.response?.data;
      dispatch(dispatchInvoiceDetailsByPQR(errorData));
      return {
        isNoRecord: isNoRecordPayload(errorData?.data ?? errorData),
        data: errorData,
      };
    });
};

export const getInvoiceDetailsByInvoiceNum = (values) => async (dispatch) => {
  try {
    const response = await axios.post(
      serviceEndPoint.GET_INVOICE_DETAILS_BY_INVOICE_NUM,
      values
    );
    dispatch(dispatchInvoiceDetailsByInvoiceNum(response.data));
    return response.data;
  } catch (error) {
    const errorData = error?.response?.data || { data: 'No record found' };
    dispatch(dispatchInvoiceDetailsByInvoiceNum(errorData));
    return errorData;
  }
};

export const getInvoiceStatusCode = (values) => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.GET_CHECK_PAYEE}?codeDomainKey=${values}`)
    .then((response) => {
      return dispatch(dispatchGetInvoiceStatusCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchGetInvoiceStatusCode(response));
    });
};

export const getInvoiceQuarter = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_INVOICE_QUARTER, values)
    .then((response) => {
      dispatch(dispatchInvoiceQuarter(response.data.data));
    })
    .catch((error) => {
      dispatch(dispatchInvoiceQuarter(error.response.data));
    });
};

export const saveInvoiceDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SAVE_INVOICE_DETAILS, values)
    .then((response) => {
      dispatch(dispatchSavedInvoiceDetails(response.data));
    })
    .catch((error) => {
      dispatch(dispatchSavedInvoiceDetails(error.response));
    });
};

export const getDrugActivity = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SHOW_DRUG_ACTIVITY, values)
    .then((response) => {
      dispatch(dispatchDrugActivity(response.data));
    })
    .catch((error) => {
      dispatch(dispatchDrugActivity(error.response));
    });
};

export const dispatchAllRebateProgramCode = (data) => {
  return {
    type: actionTypes.GET_ALL_REBATE_PROGRAMS,
    payload: data,
  };
};

export const getRebateProgramCode = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`, { planType: values })
    .then((response) => {
      return dispatch(dispatchAllRebateProgramCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchAllRebateProgramCode(response.date));
    });
};

export const getCheckLogByInvoiceNum = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.CHECK_LOG_BY_INVOICE_NUMBER}?invoiceNum=${values}`)
    .then((response) => {
      return dispatch(dispatchGetCheckLogByInvoiceNum(response.data));
    })
    .catch((response) => {
      dispatch(dispatchGetCheckLogByInvoiceNum(response.date));
    });
};

export const getMaxQuarterForFreezeDt = () => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.GET_MAXQUARTER_FOR_FREEZE_DT}`)
    .then((response) => {
      return dispatch(setDefaultQtr(response.data));
    })
    .catch((response) => {
      dispatch(setDefaultQtr(response.data));
    });
};

export const dispatchInvoiceLetterTableData = (data) => ({
  type: actionTypes.INVOICE_LETTER_TABLE_DATA,
  invoiceLetterTableData: data,
});

export const getInvoiceLetterTableData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.TEMP_TABLE_DATA, value)
    .then((response) => {
      return dispatch(dispatchInvoiceLetterTableData(response?.data));
    })
    .catch((s) => {
      dispatch(
        dispatchInvoiceLetterTableData({
          message: 'FAIL',
          status: '000',
          letterHeader: [],
        })
      );
    });
};

// get print pdf
export const updateDuplicateInvoice = (data) => ({
  type: actionTypes.INVOICE_GET_UPDATE_DUPLICATEINVOICE,
  data: data,
});

// get print pdf
export const dispatchPrintPreview = (data) => ({
  type: actionTypes.INVOICE_GET_PRINT_PREVIEW_DISPLAY,
  pdfPreview: data,
});

export const getPrintAll = (value) => async (dispatch) => {
  return await axios
    .post(serviceEndPoint.INVOICE_GET_PDF_PRINT_PREVIEW, value, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      const newData = response.data;
      return dispatch(dispatchPrintPreview(newData));
    })
    .catch((response) => {
      dispatch(dispatchPrintPreview([]));
    });
};

export const dispatchPrintCover = (data) => ({
  type: actionTypes.INVOICE_GET_REPORT_COVER_DISPLAY,
  pdfCoverPreview: data,
});

export const getPrintCover = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.INVOICE_GET_REPORT_COVER, value, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      const newData = response.data;
      return dispatch(dispatchPrintCover(newData));
    })
    .catch((error) => {
      dispatch(dispatchPrintCover());
      dispatch(setErrorMessagesData([CONSTANTS.NO_DATA_PRINT]));
    });
};

export const dispatchPrintSectionOne = (data) => ({
  type: actionTypes.INVOICE_GET_REPORT_SECTION_ONE_DISPLAY,
  pdfSectionOnePreview: data,
});

export const getPrintSectionOne = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.INVOICE_GET_REPORT_SECTION_ONE, value, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      const newData = response;
      return dispatch(dispatchPrintSectionOne(newData));
    })
    .catch((response) => {
      dispatch(dispatchPrintSectionOne([]));
    });
};

export const dispatchPrintSectionTwo = (data) => ({
  type: actionTypes.INVOICE_GET_REPORT_SECTION_TWO_DISPLAY,
  pdfSectionTwoPreview: data,
});

export const getPrintSectionTwo = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.INVOICE_GET_REPORT_SECTION_TWO, value, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      const newData = response;
      return dispatch(dispatchPrintSectionTwo(newData));
    })
    .catch((response) => {
      dispatch(dispatchPrintSectionTwo([]));
    });
};

export const dispatchPrintSectionThree = (data) => ({
  type: actionTypes.INVOICE_GET_REPORT_SECTION_THREE_DISPLAY,
  pdfSectionThreePreview: data,
});

export const getPrintSectionThree = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.INVOICE_GET_REPORT_SECTION_THREE, value, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      const newData = response;
      return dispatch(dispatchPrintSectionThree(newData));
    })
    .catch((response) => {
      dispatch(dispatchPrintSectionThree([]));
    });
};

export const dispatchSaveCoverLetter = (data) => {
  return {
    type: actionTypes.GET_SAVE_COVER_LETTER,
    payload: data,
  };
};

export const getSaveCoverLetter = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SAVE_COVER_LETTER, { rebateProgram: values })
    .then((response) => {
      return dispatch(dispatchSaveCoverLetter(response.data));
    })
    .catch((response) => {
      dispatch(dispatchSaveCoverLetter(response.data));
    });
};

export const dispatchInvGridFlag = (data) => {
  return {
    type: actionTypes.GET_INV_GRID_FLAG,
    payload: data,
  };
};

export const getInvGridFlag = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.INV_GRID_FLAG, { rebateProgram: values })
    .then((response) => {
      return dispatch(dispatchInvGridFlag(response.data));
    })
    .catch((response) => {
      dispatch(dispatchInvGridFlag(response.data));
    });
};
export const clearReduxForInvoiceReportScreen = (payload) => (dispatch) => {
  const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  if (
    (payload === '/request-invoice-report' &&
      !updateTabs.filter((x) => {
        return x.navTo === '/invoice-report-details';
      }).length > 0) ||
    (payload === '/invoice-report-details' &&
      !updateTabs.filter((x) => {
        return x.navTo === '/request-invoice-report';
      }).length > 0)
  ) {
    dispatch(resetDisplayInvoiceReportStore());
  }
};
